define('controllers/edithotelphotos',['require','lazyload','ractivejs','arrayutils','utils','rv!templates/hotelimagesList'],function(require) {
    require('lazyload');
    var Ractive = require('ractivejs');
    var arrayUtils = require('arrayutils');
    var utils = require('utils');
    var editHotelPhotosController = {
        load: function() {
            var bePatient = $("#bePatient");
            var errorMessage = $("#errorMessage");
            var infoMessage = $("#infoMessage");
            setInitialSort();
            var ractive = new Ractive({
                el: '#hotelImagesList',
                template: require('rv!templates/hotelimagesList'),
                data: {
                    Data: {
                        HotelImages: window.ServerData.feData.HotelImages
                    },
                    encodeURIComponent: window.encodeURIComponent,
                    hotelImagesUrlStart: '{0}images/hotelphotos/'.format(window.ServerData.StaticContentUrl),
                    showingSmallImages: true,
                    getShowingCount: function(photos) {
                        return photos.filter(function(p) {
                            return p.Show;
                        }).length;
                    } 
                }
                //,modifyArrays: false
            });

            ractive.on({
                /**
                 * Send delete request. Note we remove from UI right away and alert if an error occurs.
                 * @param {RactiveEvent} e 
                 */
                deleteImage: function(e) {
                    e.original.preventDefault();
                    window.ServerData.feData.HotelImages = window.ServerData.feData.HotelImages.filter(function (image) { return image.Id !== e.context.Id; });
                    setRankToCurrentOrder();
                    resetImages();
                    $.post('/api/hotels/DeleteImage/?photoId={0}'.format(e.context.Id)).then(null, function(err) {
                        alert('An error occurred while deleting: {0}'.format(err.Message));
                    });
                },

                /**
                 * Set this context to be rank 1, 
                 * @param {RactiveEvent} e 
                 */
                moveToTop: function(e) {
                    e.original.preventDefault();
                    window.ServerData.feData.HotelImages.forEach(function(photo) {
                        if (photo.Id === e.context.Id) {
                            photo.Rank = 0; //set new primary
                        } else if (photo.Rank != null) {
                            photo.Rank++; //move down other ranked photos
                        }
                    });
                    resetImages();
                },

                moveUp: function(e) {
                    move(e, true);
                },

                moveDown: move
            });

            //initialize
            lazyLoadImages();
            $('#btnGetLatestImages').on('click', getLatestImages);
            $('#btnDeleteUnused').on('click', deleteUnused);
            $("#toggleImageSize").on("click", toggleImageSize);
            $('#btnAddNewToggle').on('click', toggleAdd);
            $('#btnCancelAdd').on('click', toggleAdd);
            $("#btnSaveRankings").on("click", save);
            $('#sortable').sortable({
                stop: on_sortable_stop
            });

            /**
             * Set rank to item's index
             */
            function setRankToCurrentOrder() {
                window.ServerData.feData.HotelImages.forEach(function (photo, i) {
                    photo.Rank = i; //overwrite the rank once we get 'em sorted.
                });
            }

            /**
             * Put slide images on top, followed by new TP images, followed by the rest, ordered by size. Then run through, setting rank to that order, so we effectively only do this once.
             * Also note that we only show top 100 so it's more manageable...if this works well, consider moving the top select to the server--don't forget to order by size desc...
             * @returns {Array} 
             */
            function setInitialSort(newPhotos) {
                var newOnes = Array.isArray(newPhotos) ? arrayUtils.sort(newPhotos, 'Area', true) : [];
                var lowestRank = 0;
                var slideAndPrimary = arrayUtils.sort(window.ServerData.feData.HotelImages.filter(function (p) { return p.Rank === lowestRank || p.Show; }), 'Rank');
                var nonSlideAndPrimaryButRanked = arrayUtils.sort(window.ServerData.feData.HotelImages.filter(function (p) { return p.Rank != null && p.Rank !== lowestRank && !p.Show; }), 'Rank');
                var nonRanked = arrayUtils.sort(window.ServerData.feData.HotelImages.filter(function (p) { return p.Rank == null; }), 'Area', true); //these effectively become ranked after initial load.
                var result = slideAndPrimary.concat(newOnes).concat(nonSlideAndPrimaryButRanked).concat(nonRanked);
                window.ServerData.feData.HotelImages = result;
                setRankToCurrentOrder();
                return window.ServerData.feData.HotelImages;
            }
        
            /**
             * Since we sort them customly initially and when we get new ones (see above), simply sort by rank normally
             * @param {Array} newPhotos 
             * @returns {Array} 
             */
            function sort() {
                window.ServerData.feData.HotelImages = arrayUtils.sort(window.ServerData.feData.HotelImages, 'Rank');
                return window.ServerData.feData.HotelImages;
            }

            /**
             * If moving up, use previous rank.
             * If moving down, use the next one's rank
             * @param {ractiveEvent} e 
             * @param {bool} up 
             */
            function move(e, up) {
                e.original.preventDefault();
                var photo;
                for (var i = 0, len = window.ServerData.feData.HotelImages.length; i < len; i++) {
                    photo = window.ServerData.feData.HotelImages[i];
                    if (e.context.Id === photo.Id) {
                        var otherIndex = up ? i - 1 : i + 1;
                        var otherPhoto = window.ServerData.feData.HotelImages[otherIndex];
                        var currentRank = photo.Rank;
                        photo.Rank = otherPhoto.Rank;
                        otherPhoto.Rank = currentRank;
                        break;
                    }
                }
                resetImages();
            }

            /**
             * Sets ractive image array and resets the lazy load plugin so the correct image is shown
             * Note that we set a parent object "Data" since ractive doesn't seem to update after sortable if direct update to the images array.
             * @param {Array} newPhotos 
             */
            function resetImages(newPhotos) {
                var photos = Array.isArray(newPhotos) ? setInitialSort(newPhotos) : sort();
                ractive.set('Data.HotelImages', photos);
                lazyLoadImages();
            }

            /**
             * Set up our images to lazily load in as you scroll
             */
            function lazyLoadImages() {
                if (editHotelPhotosController.lazyload != null) {
                    editHotelPhotosController.lazyload.update();
                } else {
                    editHotelPhotosController.lazyload = Utilities.lazyLoad();
                }
            }

            /**
             * Show/hide the add images form
             */
            function toggleAdd() {
                $('#addNew').toggle();
                $('#btnAddNewToggle').toggle();
            };

            function save() {
                var $this = $(this);
                $this.prop('disabled', true);
                errorMessage.hide();
                infoMessage.hide();
                bePatient.fadeIn('slow');
                var onfinally = function() {
                    $this.prop('disabled', false);
                    bePatient.hide();
                }
                $.post('/api/hotels/SaveHotelImages/', {
                    HotelId: utils.querystring('hid'),
                    UpdatedPhotos: ractive.get().Data.HotelImages
                }).then(function (warnings) {
                    var warningMsg = warnings.length > 0 ? '<br/><strong>Warnings:</strong><br/>{0}'.format(warnings.join('<br/>')) : '';
                    infoMessage.show().html("Successfully updated image ordering, captions, and images. Be sure to view the slide show to make sure it's lookin' good.{0}".format(warningMsg));
                    onfinally();
                }, function() {
                    errorMessage.show().html("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
                    onfinally();
                });
            }

            /**
             * Toggle between showing small/more-manageable images and the size they will be shown to the end user
             */
            function toggleImageSize() {
                ractive.set('showingSmallImages', !ractive.get('showingSmallImages'));
                resetImages();
            }

            /**
             * Tell server to grab latest tp images for this hotel and send the new ones back. 
             * Put the new ones just below the current slideshow images
             */
            function getLatestImages() {
                var $this = $(this);
                $this.prop('disabled', true);
                $.get('/api/hotels/GetNewPhotosFromTravelPort/?hotelId={0}'.format(utils.querystring('hid'))).then(function(newPhotos) {
                    resetImages(newPhotos);
                    $this.prop('disabled', false);
                    toggleAdd();
                }, function(err) {
                    errorMessage.show().html(err.Message);
                    $this.prop('disabled', false);
                });
            }

            /**
             * Removes any images that aren't being used as the main search image or in the slide show
             * @returns {} 
             */
            function deleteUnused() {
                var $this = $(this);
                $this.prop('disabled', true);
                $.post('/api/hotels/DeleteUnused/?hotelId={0}'.format(utils.querystring('hid'))).then(function(deletedPhotoIds) {
                    window.ServerData.feData.HotelImages = window.ServerData.feData.HotelImages.filter(function(image) { return deletedPhotoIds.some(function(deletedId) { return image.Id === deletedId; }); });
                    resetImages();
                    $this.prop('disabled', false);
                }, function(err) {
                    errorMessage.show().html(err.Message);
                    $this.prop('disabled', false);
                });
            }

            /**
             * When the photo record is dragged and dropped update the ordering appropriately based on the ordering of the DOM list item elements
             * @param {jqueryUiEvent} e 
             * @param {jqueryUiContext} ui 
             */
            function on_sortable_stop(e, ui) {
                var id;
                var photo;
                $('#sortable li').each(function (index) {
                    id = parseInt(this.id);
                    photo = window.ServerData.feData.HotelImages.filter(function (image) { return image.Id === id; })[0];
                    if (photo.Rank !== index) {
                        photo.Rank = index;
                    }
                });
                ractive.set('Data.HotelImages', window.ServerData.feData.HotelImages);
                //resetImages();
            }
        },

        unload: function () {
            if (editHotelPhotosController.ractive != null) { editHotelPhotosController.ractive.teardown(); }
            if (editHotelPhotosController.lazyload != null) { editHotelPhotosController.lazyload.destroy(); }
        }
    }
    return editHotelPhotosController;
});

